import appRedirector from "../../views/appSettings/redirector.html";
import constants from "../../core/constants";
import { getState } from "../../core/utils";

function urlsConfig($stateProvider) {
  "ngInject";

  const base = "redirector";
  const params = ["page", "limit"];

  $stateProvider.state("redirector", {
    url: getState(base, params),
    parent: "app",
    views: {
      view: {
        template: appRedirector,
      },
    },
    reloadOnSearch: false,
    data: { title: "Redirector" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/redirector/redirector.urls.js